import { LineChart as MuiLineChart, LineChartProps } from '@mui/x-charts';
import React from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { useLocaleAxes } from 'components/charts/hooks/use-locale-axes';
import { useLocaleSeries } from 'components/charts/hooks/use-locale-series';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const LineChart = React.forwardRef<HTMLDivElement, LineChartProps & ChartSurfaceProps>(function LineChart({ dark, ...props }, ref) {
  const { formatValue } = useChartLocale();
  const series = useLocaleSeries(props.series, formatValue);
  const xAxis = useLocaleAxes(props.xAxis);
  const yAxis = useLocaleAxes(props.yAxis);

  return (
    <ChartThemeScope dark={dark}>
      <MuiLineChart {...props} ref={ref} series={series} xAxis={xAxis} yAxis={yAxis} />
    </ChartThemeScope>
  );
});

export default LineChart;
